export enum Fields4A3W {
  ACTION = 'action',
  ACTOR = 'actor',
  ASSET = 'asset',
  ATTRIBUTE = 'attribute',
  WHY = 'why',
  WHO = 'who',
  WHAT = 'what',
}
